import { useQuery } from "@tanstack/react-query";
import { getKycList } from "@/services/kyc.service";

export const useKycList = (
  enabled = true,
  params = {
    page: 1,
    size: 10,
    order: "",
    approvalStatus: "",
    businessType: "",
    search: "",
  },
  options = {},
) => {
  const queryKey = [
    "kyc-list",
    params.page,
    params.size,
    params.order,
    params.approvalStatus,
    params.businessType,
    params.search,
  ];

  return useQuery({
    queryKey,
    queryFn: () => getKycList(params),
    enabled,
    ...options,
  });
};
